import { SxProps, styled } from '@mui/material/styles';
import { hexToRgba, useStacklineTheme } from '@stackline/ui';
import React from 'react';
import { SlButton, SlButtonProps } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import colors from 'src/utils/colors';

const StyledButton = styled(SlButton)(
  (props: { textColor?: string; backgroundColor: string; disableHover?: boolean }) => {
    const { textColor, backgroundColor, disableHover } = props;
    const style = {
      '& p': {
        fontSize: '12px',
        fontWeight: 500,
        color: textColor
      },
      border: 'none',
      padding: '6px 8px',
      minWidth: 'unset',
      height: 'unset',
      backgroundColor
    };

    return disableHover ? Object.assign(style, { '&:hover': { backgroundColor } }) : style;
  }
);

export type MiniButtonProps = Pick<SlButtonProps, 'children' | 'onClick'> & { sx?: SxProps };

/**
 * Tiny button with 8px font size and minimal padding
 */
const MiniButton = (props: MiniButtonProps) => {
  const theme = useStacklineTheme();
  return <StyledButton backgroundColor={hexToRgba(theme.colors.primaryLight, 0.1)} {...props} />;
};

/**
 * Mini button styled for segment cards
 */
const SegmentMiniButton = (props: MiniButtonProps) => {
  return <StyledButton textColor="#46a8f6" backgroundColor={colors.lightestBlue} {...props} disableHover />;
};

/**
 * Mini button styled for topic cards
 */
const TopicsMiniButton = (props: MiniButtonProps) => {
  return <StyledButton textColor="#ed792f" backgroundColor="#fdf2ea" {...props} disableHover />;
};

export default MiniButton;
export { SegmentMiniButton, TopicsMiniButton };
